export const MERCHANT_MIN_PICKUP_HOURS = 2;
